// =============================================================
// AuthImage — load a Firebase Storage file via getDownloadURL.
// =============================================================
// Storage rules (storage.rules) allow ANY authenticated user to read
// tournament photos (so the leaderboard works), but only the owner
// can write/delete them.
// =============================================================

import { useEffect, useState } from "react";
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../lib/firebase";

export default function AuthImage({ path, alt, className, fallback = null }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!path) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const downloadUrl = await getDownloadURL(ref(storage, path));
        if (!cancelled) setUrl(downloadUrl);
      } catch (err) {
        console.error("AuthImage load failed", err);
        if (!cancelled) setError(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [path]);

  if (error || !path) return fallback;
  if (!url) {
    return <div className={`${className || ""} bg-[#141414] animate-pulse`} aria-busy="true" />;
  }
  return <img src={url} alt={alt} className={className} />;
}
